module.exports = __webpack_public_path__ + "media/src/images/balloons/banner_summersale_small_de-6338f39d4e63530f6e28e78faef93fa7.jpg";